// Hero Section
gsap.from(".t4s-content-position", {
    opacity:0,
    y: 100,
    duration: 1,
    delay: 1,
    stagger:0.5,
    scale: 0.2
}); 

gsap.to(".t4s-content-position h2", {
    color: "#ffcc02",
    duration: 2,
    delay: 2,
    repeat: -1,
});


// Content With Slider -> Heading
gsap.fromTo(
  ".animate-heading",
  { y: 50, opacity: 0 },
  { 
    y: 0, opacity: 1, 
    scrollTrigger: {
      trigger: ".animate-heading",
      start: "top 90%", 
      end: "bottom 10%", 
    }
  }
);

// Content With Slider -> Text
gsap.fromTo(
  ".animate-text",
  { y: 50, opacity: 0 }, // Initial state
  { 
    y: 0, opacity: 1, 
    scrollTrigger: {
      trigger: ".animate-text",
      start: "top 90%",
      end: "bottom 10%",
    }
  }
);

// Content With Slider -> Button
gsap.fromTo(
  ".animate-button",
  { y: 50, opacity: 0 },
  { 
    y: 0, opacity: 1, 
    scrollTrigger: {
      trigger: ".animate-button",
    }
  }
);

// Product Collection Title
gsap.fromTo(
  ".t4s-title",
  { y: 50, opacity: 0 }, // Initial state
  { 
    y: 0, opacity: 1, duration: 1, 
    scrollTrigger: {
      trigger: ".t4s-title",
      start: "top 90%", 
      end: "bottom 10%", 
      toggleActions: "restart none none reset", 
      onLeaveBack: () => gsap.set(".t4s-title", { opacity: 0, y: 50 }), 
    }
  }
);

// New Arrival Button

gsap.from(".t4s-viewall-btn", {
  opacity: 0,
  y: 30,  
  ease: "power3.out",
  scrollTrigger: {
    trigger: ".t4s-viewall-btn",
  }
});

// Product Collection Button

gsap.from(".t4s-loadmore-btn", {
  opacity: 0,
  y: 30,  
  ease: "power3.out",
  scrollTrigger: {
    trigger: ".t4s-loadmore-btn",
  }
});

// News In -> Text
gsap.from(".t4s-w-100 p", {
  opacity: 0,
  y: 50,
  scrollTrigger: {
    trigger: ".t4s-w-100 p"
  }
});

gsap.from(".t4s-w-100 h4", {
  opacity: 0,
  y: 50,
  scrollTrigger: {
    trigger: ".t4s-w-100 h4"
  }
});

gsap.from(".t4s-col-inner-wrap a", {
  opacity: 0,
  y: 30,
  ease: "power3.out",
  scrollTrigger: {
    trigger: ".t4s-col-inner-wrap a",
  }
});




// Custom Collection Slider
gsap.from(".custom-collection-box", {
  opacity:0,
  y:50,
  stagger: 0.3,
  scrollTrigger: ".custom-collection-box"
})

// Collection List
gsap.from(".t4s-collection-item", {
  opacity:0,
  y:50,
  stagger: 0.3,
  scrollTrigger: ".t4s-collection-item"
})

// What Client Say
gsap.from(".t4s-custom-col", {
  opacity:0,
  y:50,
  stagger: 0.3,
  scrollTrigger: ".t4s-custom-col"
})


// signup section
// gsap.from(".t4s_se_template--20693288943940__custom_section_k6KMDR", {
//   opacity:0,
//   scale:2,
//   delay:0.5,
//   x:-300,
//   duration:1,
//   scrollTrigger: ".t4s_se_template--20693288943940__e6ed1cdf-596f-4391-8286-32d4734d4f1f"
// })
